import React from "react";
import { motion } from "framer-motion";

const Partnership = () => {
  return (
    <>
    <div className="absolute left-[10%] top-[25%] w-[250px] h-[250px] md:w-[350px] md:h-[350px] bg-[#ff6572] opacity-20 blur-[150px] rounded-full z-0"></div>
        <div className="absolute right-[10%] top-[25%] w-[250px] h-[250px] md:w-[350px] md:h-[350px] bg-[#ff6572] opacity-20 blur-[150px] rounded-full z-0"></div>

        {/* Bottom Pink Blobs */}
        <div className="absolute left-[15%] bottom-[10%] w-[250px] h-[250px] md:w-[350px] md:h-[350px] bg-[#e308a2] opacity-20 blur-[150px] rounded-full z-0"></div>
        <div className="absolute right-[15%] bottom-[10%] w-[250px] h-[250px] md:w-[350px] md:h-[350px] bg-[#e308a2] opacity-20 blur-[150px] rounded-full z-0"></div>

        {/* Top Green Blobs */}
        <div className="absolute left-[50%] top-[5%] transform -translate-x-1/2 w-[250px] h-[250px] md:w-[350px] md:h-[350px] bg-[#70b616] opacity-20 blur-[150px] rounded-full z-0"></div>
        <div className="absolute right-[50%] top-[5%] transform translate-x-1/2 w-[250px] h-[250px] md:w-[350px] md:h-[350px] bg-[#70b616] opacity-20 blur-[150px] rounded-full z-0"></div>

    <section className="relative text-center py-16 px-6 overflow-hidden">
      {/* Background Blur Elements */}
      
        
      

      {/* Animated Tagline */}
      <motion.div
        className="relative font-[Nunito] inline-block bg-[#432DD7] text-white px-6 py-3 md:px-8 md:py-4 rounded-full text-xs md:text-sm"
        initial={{ x: 100, opacity: 0 }}
        whileInView={{ x: 0, opacity: 1 }}
        transition={{ duration: 1.2, ease: "easeOut" }}
        viewport={{ once: true }}
        >
        Partnership Opportunities
      </motion.div>

      {/* Main Heading */}
      <motion.h1
        className="relative text-xl md:text-[40px] text-[30px] font-bold text-black mt-4"
        initial={{ x: 100, opacity: 0 }}
        whileInView={{ x: 0, opacity: 1 }}
        transition={{ duration: 1.2, ease: "easeOut" }}
        viewport={{ once: true }}
        style={{fontFamily:"PT Sans"}}
        >
        Partner with Godhani Technology
      </motion.h1>

      {/* Animated Subheading */}
      <motion.p
        style={{ fontFamily: "Allison, sans-serif" }}
        className="relative text-2xl md:text-3xl lg:text-6xl text-purple-600 mt-2"
        initial={{ x: 100, opacity: 0 }}
        whileInView={{ x: 0, opacity: 1 }}
        transition={{ duration: 1.2, ease: "easeOut" }}
        viewport={{ once: true }}
        >
        for innovative, reliable, and scalable IT solutions.
      </motion.p>

      {/* Description */}
      <motion.p
        className=" max-w-3xl text-sm md:text-lg lg:text-xl mx-auto mt-4 px-4"
        initial={{ x: 100, opacity: 0 }}
        whileInView={{ x: 0, opacity: 1 }}
        transition={{ duration: 1.2, ease: "easeOut" }}
        viewport={{ once: true }}
        >
        Join forces with us to deliver exceptional IT solutions and create mutual growth opportunities. We believe in building strong, lasting partnerships that benefit all parties involved.
      </motion.p>
    </section>
        </>
  );
};

export default Partnership;
